import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import styles from './UpsertModule.module.css';

export default function SelectModuleTemplate({
  moduleTemplates,
  moduleTemplate,
  setModuleTemplate,
  className
}) {
  const handleModuleTemplateChange = (e) => {
    const template = moduleTemplates.find(
      (potentialTemplate) => potentialTemplate.carModel === e.target.value
    );
    setModuleTemplate(template);
  };
  return (
    <div className={className}>
      <FormControl className={styles.moduleTemplateSelect}>
        <InputLabel id="demo-simple-select-label">Module template</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={moduleTemplate ? moduleTemplate.carModel : ''}
          onChange={handleModuleTemplateChange}
        >
          {moduleTemplates &&
            moduleTemplates.map((row, keyIndex) => (
              <MenuItem key={keyIndex} value={row.carModel}>
                {`${row.carModel} - ${row.moduleType}`}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
}
